import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class modalEditionFinDeMois extends Vue {
	public dernierExercice?: ExerciceDto;
	public premierExercice?: ExerciceDto;
	public moisSelectionne = 0;
	public anneeSelectionnee = 0;
	public isLoading = false;

	public init(): void {
    	this.isLoading = true;

    	$("#modalEditionFinDeMois").modal("show");

    	this.initExerciceParDefaut();

    	this.isLoading = false;
	}

	public initExerciceParDefaut(): void {
    	ServicesFactoryInstance.ExercicesService.getDernierExercice(data => {
    		if (data == undefined) {
    			NotificationServiceInstance.SendFailed("Aucun exercice n'a été trouvé.");
    			this.annuler();
    		}
    		this.dernierExercice = data;
    		this.anneeSelectionnee = this.dernierExercice.Annee;
    		this.moisSelectionne = this.dernierExercice.Mois;

    		this.$forceUpdate();
    	});
	}

	public annuler(): void {
    	$("#modalEditionFinDeMois").modal("hide");
	}

	public valider(): boolean | void {
		if (this.anneeSelectionnee == undefined) {
    		NotificationServiceInstance.SendFailed("L'année doit être renseignée");

    		return;
    	}
    	if (isNaN(Number(this.anneeSelectionnee))) {
    		NotificationServiceInstance.SendFailed("L'année doit être un entier");

    		return;
    	}

    	NotificationServiceInstance.SendInformation("Les éditions de fin de mois seront bientôt disponibles.");
    	this.isLoading = true;

    	ServicesFactoryInstance.EditionsService.editionFinDeMoisByAnneeEtMoisExercice(this.anneeSelectionnee, this.moisSelectionne, () => {
    		NotificationServiceInstance.SendSuccess("Les éditions de fin de mois sont disponibles");
    		this.isLoading = false;
    		this.annuler();
    	},
    	() => {
    		NotificationServiceInstance.SendFailed("Les éditions de fin de mois ont échoué.");
    		this.isLoading = false;
    		this.annuler();
    	}
    	);
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalEditionFinDeMois/modalEditionFinDeMois.ts